import { RouteConfig } from 'vue-router'

// 基础素材/信息二级
const filesBaseRouter: RouteConfig = {
  name: 'FilesBase',
  path: 'files-base',
  redirect: '/files/files-base/files-base-label',
  component: () => import('@/views/files/files-base/files-base.vue'),
  meta: {
    title: '基础数据'
  },
  children: [
    {
      name: 'FilesBaseLabel',
      path: 'files-base-label',
      component: () => import('@/views/files/files-base/label.vue'),
      meta: {
        title: '分类'
      }
    },
    {
      name: 'FilesBaseTag',
      path: 'files-base-tag',
      component: () => import('@/views/files/files-base/tag.vue'),
      meta: {
        title: '角标'
      }
    },
    {
      name: 'FilesLabelAddEdit',
      path: 'files-label-add-edit',
      component: () => import('@/views/files/files-base/files-label-add-edit.vue'),
      meta: {
        title: '添加/修改分类'
      }
    }
    // {
    //   name: 'FilesBaseResource',
    //   path: 'files-base-resource',
    //   component: () => import('@/views/files/files-base/resource.vue'),
    //   meta: {
    //     title: '资源分类'
    //   }
    // }
  ]
}

export default filesBaseRouter
